import React, { useEffect, useState } from "react";

import useTranslation from "next-translate/useTranslation";
import styles from "./styles/Lobby.module.css";
import LobbyPopups from "./popups/LobbyPopups";
import Head from "next/head";
import {
  useLobby,
  enterLobby,
  // exitLobby,
  showChallengePopup,
  chooseGame,
  setTab,
} from "../../redux/lobby";
import {
  CREATE_GAME_TAB,
  DAILY_TAB,
  LIVE_GAME_TAB,
  // CREATE_GAME_TAB,
  // DAILY_TAB,
  // LIVE_GAME_TAB,
  ModeIds,
  TimeControl,
  VARIANT_CHESS,
} from "@chesshotel/constants";
import { getModeId } from "../../util/util";
// import {  } from "../ducks/lobby";
import { REGULAR_TIER, UNLIMITED_TIER } from "@chesshotel/constants";
// import { getModeId } from "../../util/util";
import LobbyBody from "./LobbyBody";
import PlayWire from "../../components/PlayWire";
import {
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_ADSENSE,
  ADS_PROVIDER_PLAYWIRE,
  useSiteData,
} from "../../redux/siteData";
import { useMembership } from "../../redux/membership";
import AdSense from "../../components/AdSense";
import { useRouter } from "next/router";
import ChallengePopup from "../challenge/ChallengePopup";
import CustomGamePopup from "./popups/CustomGamePopup";
import LobbyHead from "./LobbyHead";
import CreateGame from "./CreateGame";
import { useSettings } from "@/redux/settings";
import { preloadChessImages } from "../../util/imagePreloader";
import pieceStyles from "../../chessBoard/components/Piece.module.css";
import boardStyles from "../../chessBoard/components/Board.module.css";
import { useSignIn } from "@/redux/signIn";
import { useWsConnection } from "@/redux/wsConnection";
import { getGameReviewBucket } from "@/lib/next-yandex-metrica/buckets";

function initLobbyChosenGame() {
  try {
    const timeVal = localStorage.getItem("chosenTime");
    const incVal = localStorage.getItem("chosenInc");
    const variantVal = localStorage.getItem("chosenVariant");
    const turnLengthVal = localStorage.getItem("turnLength");
    const timeControlVal = localStorage.getItem("timeControl");

    const time = timeVal ? parseInt(timeVal) : 10;
    const inc = incVal ? parseInt(incVal) : 0;
    const variant = variantVal ? parseInt(variantVal) : VARIANT_CHESS;
    const timeControl = timeControlVal
      ? parseInt(timeControlVal)
      : TimeControl.LIVE;
    const turnLength = turnLengthVal ? parseInt(turnLengthVal) : 2;

    if (timeControl == TimeControl.LIVE) {
      if (typeof window !== "undefined") {
        if (window.innerWidth <= 768) {
          setTab(CREATE_GAME_TAB);
        } else {
          setTab(LIVE_GAME_TAB);
        }
      }
    } else {
      setTab(DAILY_TAB);
    }

    chooseGame({
      time,
      inc,
      variant,
      modeId: getModeId(time, variant, timeControl),
      turnLength,
      timeControl,
    });
  } catch (e) {
    chooseGame({
      time: 10,
      inc: 0,
      variant: VARIANT_CHESS,
      modeId: ModeIds.RAPID,
      timeControl: TimeControl.LIVE,
      turnLength: 2,
    });
  }
}

async function initPlayWire(isDesktop) {
  const pwUnits = [];

  // if (sideAd && isDesktop) {
  //   pwUnits.push({
  //     selectorId: "lobby_skyscraper_left",
  //     type: "sky_atf",
  //   });
  if (isDesktop) {
    pwUnits.push({
      selectorId: "lobby_skyscraper_right",
      type: "sky_atf",
    });
  } else {
    pwUnits.push({
      selectorId: "lobby_bottom",
      type: "leaderboard_atf",
    });
  }
  // pwUnits.push({
  //   selectorId: "lobby_bottom",
  //   type: "leaderboard_btf",
  // });
  // }

  if (window.ramp) {
    try {
      await window.ramp.destroyUnits("all");
      await window.ramp.addUnits(pwUnits);
      await window.ramp.displayUnits();
    } catch (error) {
      console.log(error);
    }
  }
}

function initYandex(isDesktop) {
  // window.yaContextCb.push(() => {
  //   window.Ya.Context.AdvManager.render({
  //     renderTo: "yandex_rtb_R-A-1674804-8",
  //     blockId: "R-A-1674804-8",
  //   });
  // });

  if (isDesktop) {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-5",
        blockId: "R-A-1674804-5",
      });
    });
  } else {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-9",
        blockId: "R-A-1674804-7",
      });
    });
  }
}

function preloadStockfish() {
  const showGameReviewButton = getGameReviewBucket();

  const preloadQuick = async () => {
    // Preload the Stockfish worker early so end-of-game quick pass is instant
    try {
      const mod = await import("@/modules/gameReview/stockfishPool");
      // Preload only a single worker on first load; GameReviewStart will expand the pool.
      await mod.initStockfishPool(true, 1, true);
    } catch (e) {}
    // Optionally also preload the quick client review module
    try {
      await import("@/modules/gameReview/quickClientReview");
    } catch (e) {}
  };
  if (showGameReviewButton) {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(preloadQuick);
    } else {
      setTimeout(preloadQuick, 5000);
    }
  }
}
export default function Lobby() {
  const { t } = useTranslation("common");

  const { customGamePopupVisible, challengePopupVisible } = useLobby();
  const { adsVisible, adsProvider } = useSiteData();
  const { tier } = useMembership();
  const { loading } = useSignIn();
  const { wsConnected } = useWsConnection();
  // const { memberLoggedIn } = useUser();
  const { chessSet, isDesktop } = useSettings();

  const router = useRouter();

  useEffect(() => {
    router.prefetch("/game");
    initLobbyChosenGame();
    window.scrollTo(0, 0);
    enterLobby();

    // Preload chess images for the game page
    if (chessSet) {
      preloadChessImages(chessSet);
    }
    if (isDesktop) {
      preloadStockfish();
    }
  }, [chessSet, isDesktop]);

  useEffect(() => {
    if (
      !adsVisible ||
      isDesktop === null ||
      tier === REGULAR_TIER ||
      tier === UNLIMITED_TIER
    ) {
      return;
    }

    if (adsProvider === ADS_PROVIDER_PLAYWIRE) {
      initPlayWire(isDesktop);
    } else if (adsProvider === ADS_PROVIDER_YANDEX) {
      initYandex(isDesktop);
    }
  }, [adsVisible, adsProvider, tier, isDesktop]);

  function renderSideAdRight() {
    if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
      return null;
    }

    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return (
          <div
            id="lobby_skyscraper_right"
            className="flex flex-col md:w-[160px] h-[600px]"
            // contStyles="h-[600px]"
          />
        );

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.sideAd}
            showRemoveAds={false}
            slot="7152821243"
            format="auto"
            insStyle={{ width: "100%" }}
          />
        );

      case ADS_PROVIDER_YANDEX:
        return (
          <div
            className="flex flex-col md:w-[160px] h-[600px]"
            id="yandex_rtb_R-A-1674804-5"
          ></div>
        );

      default:
        return null;
    }
  }

  function renderFooterAd() {
    if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
      return null;
    }

    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return <PlayWire id="lobby_bottom" className={styles.footerAd} />;

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.footerAd}
            showRemoveAds={false}
            slot="6991788029"
            format="auto"
            insStyle={{ width: "100%", height: "120px" }}
          />
        );
      case ADS_PROVIDER_YANDEX:
        return (
          <div className={styles.footerAd} id="yandex_rtb_R-A-1674804-9"></div>
        );

      default:
        return <div className={styles.footerAd}></div>;
    }
  }

  return (
    <>
      <Head>
        <title>Chess Hotel | Lobby</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
      </Head>
      {customGamePopupVisible && <CustomGamePopup />}
      {challengePopupVisible && (
        <ChallengePopup
          onClose={() => showChallengePopup(false)}
          friend={null}
        />
      )}
      <LobbyPopups />
      <div className="flex w-full">
        <div className="flex justify-center px-1 pb-4 w-full shrink md:px-2">
          <div className="flex flex-col w-full max-w-[1000px] px-2 md:px-0">
            <LobbyHead />
            <div className="flex flex-col mb-3 w-full md:flex-row md:justify-center md:mb-4">
              <div className="flex flex-col rounded-t-xl rounded-b-md shrink basis-7/12">
                <LobbyBody isDesktop={isDesktop} />
              </div>
              <div className="hidden relative flex-col w-full md:flex md:basis-5/12 md:shrink-0 md:ml-4">
                <CreateGame isDesktop={isDesktop} />
              </div>
            </div>
            {!isDesktop && renderFooterAd()}
          </div>
        </div>
        {tier !== REGULAR_TIER && tier !== UNLIMITED_TIER ? (
          <div className="hidden md:flex shrink-0 transition-none md:w-[184px] p-3 h-[624px] bg-gray-200">
            {isDesktop && renderSideAdRight()}
          </div>
        ) : (
          <div className="hidden w-0 bg-gray-200 transition-all duration-500 md:flex"></div>
        )}
      </div>
      {/* Force CSS background image loading */}
      <div
        style={{
          position: "absolute",
          visibility: "hidden",
          width: 0,
          height: 0,
        }}
      >
        <div className={boardStyles[chessSet]}></div>
        <div
          className={`${pieceStyles[`${chessSet}_wP`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_wN`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_wB`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_wR`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_wQ`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_wK`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_bP`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_bN`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_bB`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_bR`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_bQ`]} ${pieceStyles.piece}`}
        ></div>
        <div
          className={`${pieceStyles[`${chessSet}_bK`]} ${pieceStyles.piece}`}
        ></div>
      </div>
    </>
  );
}
